import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';

import { useA11ySelector } from '@sg/a11y-helpers';

import { StripeCustomerSheet } from '@order/integrations/stripe';

import { AccountScreenContainer, AccountScreenTitle, SignedOutView } from '../../components';
import { useIsLoggedIn } from '../../context/AuthMachine';

// ─────────────────────────────────────────────────────────────────────────────

export const PaymentAndGiftCardsScreen = () => {
  const router = useRouter();

  const { formatMessage } = useIntl();
  const title = formatMessage(messages.title);
  const containerA11ySelector = useA11ySelector('account.payments.container');

  // ─── Flags ───────────────────────────────────────────────────────────

  const isLoggedIn = useIsLoggedIn();

  // ─────────────────────────────────────────────────────────────────────

  const handleClose = useCallback(() => {
    if (router.canGoBack()) {
      router.back();

      return;
    }

    router.dismissTo('/account');
  }, [router]);

  if (!isLoggedIn) {
    return <SignedOutView redirectTo="/account/payment-and-gift-cards" withoutFooter />;
  }

  return (
    <AccountScreenContainer screen="payment-and-gift-cards" {...containerA11ySelector.props}>
      <AccountScreenTitle title={title} />

      <StripeCustomerSheet visible redirectTo={redirectTo} onClose={handleClose} />
    </AccountScreenContainer>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const redirectTo = `https://${window.location.host}/account/payment-and-gift-cards`;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Payments',
    description: 'Payments Screen | Title',
  },
});
